import { dialog } from "nq-component";
import { findObjectUseCase, upsertUseCase } from "../../usecases/object";
import { convertTo24HourTime } from "../common/Converter";
import BaseFormPage from "../../base/BaseFormPage";

function convertTo24Hour(time) {
  const [timePart, meridian] = time.split(" "); // Split the time and AM/PM
  let [hour, minute] = timePart.split(":").map(Number);

  if (meridian === "PM" && hour !== 12) {
    hour += 12; // Add 12 to convert PM times except 12 PM
  } else if (meridian === "AM" && hour === 12) {
    hour = 0; // Convert 12 AM to 0 (midnight)
  }

  // Return in 24-hour format with zero-padding for hours and minutes
  return `${hour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;
}

function getOvertimeDuration(timeIn, timeOut) {
  const [timeInHour, timeInMinute, timeInSecond] = timeIn
    .split(":")
    .map(Number);
  const [timeOutHour, timeOutMinute, timeOutSecond] = timeOut
    .split(":")
    .map(Number);

  // Convert timeIn and timeOut to seconds
  const timeInSeconds = timeInHour * 3600 + timeInMinute * 60 + timeInSecond;
  const timeOutSeconds =
    timeOutHour * 3600 + timeOutMinute * 60 + timeOutSecond;

  // Calculate the difference in seconds
  const durationInSeconds = timeOutSeconds - timeInSeconds;

  let plainHours = Math.floor(durationInSeconds / 3600);
  if (plainHours < 0) {
    plainHours = "0";
  }
  return plainHours.toString(); // Assign to data.overtime
}

function HierarchyQuery(employee) {
  const fields = ["region", "office", "division", "section", "unit", "cluster"];

  const fieldNameMap = {
    cluster: "plantilla",
    region: "regions",
    office: "offices",
    division: "divisions",
    section: "sections",
    unit: "units",
  };

  const lastNonEmptyField = fields
    ?.slice()
    .reverse()
    .find((field) => employee[0][field]);

  const mappedField = lastNonEmptyField
    ? fieldNameMap[lastNonEmptyField] || lastNonEmptyField
    : null;

  const lastNonEmptyValue = lastNonEmptyField
    ? employee[0][lastNonEmptyField]
    : null;

  return {
    [mappedField]: lastNonEmptyValue,
  };
}

export default class TimeManagementStatus extends BaseFormPage {
  async execute(
    schedule,
    currentUser,
    dayInLength,
    object,
    dailyTime,
    refetchData,
    stats
  ) {
    try {
      const employee = currentUser.employee;
      const currentYear = dayInLength.getFullYear().toString();
      const currentMonth = dayInLength.getMonth().toString();
      const dayOfWeek = this.getDayOfWeek(dayInLength);
      const timeRecStats = [];
      const [listOfEmployee, listofLeaves, leave_cred] = await this.fetchData(
        employee,
        object,
        dailyTime
      );

      let data = this.prepareData(
        dailyTime,
        object,
        employee,
        currentYear,
        currentMonth,
        timeRecStats
      );

      // find holiday
      const hierarchy = HierarchyQuery(listOfEmployee);
      const listofHolidays = await findObjectUseCase().execute("holidays", {
        where: { ...hierarchy, date: object.currentDate },
      });

      // find suspension
      const listofSuspension = await findObjectUseCase().execute("suspension", {
        where: {
          ...hierarchy,
          status: "active",
          dateFrom: { $lte: `${object.currentDate} at ${object.currentTime}` },
          dateTo: { $gte: `${object.currentDate} at ${object.currentTime}` },
        },
      });

      this.handleHolidays(listofHolidays, data, timeRecStats);
      this.handleLeaves(listofLeaves, data, timeRecStats);
      this.handleSuspension(listofSuspension, data, timeRecStats);

      // const scheduleObject = listOfEmployee[0]?.selectedSchedule;

      // const nextDayMap = {
      //   Sunday: "Monday",
      //   Monday: "Tuesday",
      //   Tuesday: "Wednesday",
      //   Wednesday: "Thursday",
      //   Thursday: "Friday",
      //   Friday: "Saturday",
      //   Saturday: "Sunday",
      // };

      // let schedule = scheduleObject?.scheduleArray?.find(
      //   (sched) => sched.day === dayOfWeek
      // );
      // if (scheduleObject.selectedOption === "Graveyard") {
      //   schedule = scheduleObject?.scheduleArray?.find(
      //     (sched) => sched.day === `${dayOfWeek} - ${nextDayMap[dayOfWeek]}`
      //   );
      // }

      // console.log("TESTTTTTTTTTT ", dailyTime);
      // return;
      // const dateToday = new Date();
      // const find = {
      //   where: {
      //     stats: "Approved",
      //     forCOC: true,
      //     counted: "false",
      //     dateStarted: dateToday.toISOString().split("T")[0],
      //     "employee.id": listOfEmployee[0].id,
      //   },
      //   keys: ["overtime"],
      // };
      // const empOvertime = await findObjectUseCase().execute("overtime", find);

      if (listOfEmployee.length > 0 && schedule) {
        if (listofHolidays.length === 0 && listofLeaves.length === 0) {
          this.checkSchedule(
            schedule,
            listOfEmployee[0],
            dayOfWeek,
            object,
            data,
            timeRecStats,
            dailyTime
          );
        }
        const empEmail = listOfEmployee[0].id;
        const timeOut = schedule.timeout;

        const hasLeaveCred = await findObjectUseCase().execute("leave_cred", {
          where: { empID: empEmail, type: "Vacation Leave" },
        });

        if (stats === "Update") {
          const daily_rec = dailyTime[0];
          data.overtime = getOvertimeDuration(timeOut, data.timeOut);
          if (daily_rec.newlyHiredDeduct) {
            const minTotal = this.computeCreditDeduction(
              Math.abs(object.totalMinute)
            );
            if (parseFloat(object.totalMinute) < 0) {
              data.newlyHiredDeduct =
                parseFloat(daily_rec.newlyHiredDeduct) + parseFloat(minTotal);
              data.lateMinutes =
                parseFloat(daily_rec.lateMinutes) + parseFloat(minTotal);
              if (leave_cred.length > 0) {
                let current =
                  parseFloat(leave_cred[0].current) - parseFloat(minTotal);

                leave_cred[0].current = current.toFixed(3);
                // await upsertUseCase().execute("leave_cred", leave_cred[0]);
              }
            } else {
              let newly =
                parseFloat(daily_rec.newlyHiredDeduct) - parseFloat(minTotal);
              let lateMin =
                parseFloat(daily_rec.lateMinutes) - parseFloat(minTotal);
              if (newly < 0) {
                lateMin =
                  parseFloat(daily_rec.lateMinutes) -
                  Math.abs(newly) -
                  parseFloat(daily_rec.newlyHiredDeduct);

                if (leave_cred.length > 0) {
                  let current =
                    parseFloat(leave_cred[0].current) + Math.abs(newly);
                  if (current < 0) {
                    current = 0;
                  }
                  console.log("Added Cred: ", current);
                  leave_cred[0].current = current.toFixed(3);
                  // await upsertUseCase().execute("leave_cred", leave_cred[0]);
                }
                newly = 0;
              }
              data.newlyHiredDeduct = newly.toFixed(3);

              if (lateMin < 0) {
                lateMin = 0;
              }

              data.lateMinutes = lateMin.toFixed(3);
            }
          }
        } else {
          data.overtime = getOvertimeDuration(timeOut, data.timeIn);
        }

        // if (data.timeOut !== "--:--") {
        //   if (empOvertime.length > 0) {
        //     empOvertime[0].overtime = data.overtime;
        //     await upsertUseCase().execute("overtime", empOvertime[0]);
        //   }
        // }
        const deductionValue = parseFloat(data.lateMinutes);

        if (data.timeOut !== "--:--" && stats !== "Update") {
          // console.log("LEAAVEE: ", hasLeaveCred);
          let newlyHiredDeduct = 0;
          // console.log("NEWWLLL: ", newlyHiredDeduct);
          if (hasLeaveCred.length > 0) {
            let current = parseFloat(hasLeaveCred[0].current) - deductionValue;
            if (current < 0) {
              newlyHiredDeduct = Math.abs(current);
              current = 0;
            }

            hasLeaveCred[0].current = current.toFixed(3);
            // console.log("LEAVE: ", hasLeaveCred[0]);
            // await upsertUseCase().execute("leave_cred", hasLeaveCred[0]);
          } else {
            newlyHiredDeduct = deductionValue;
          }
          data.newlyHiredDeduct = newlyHiredDeduct.toFixed(3);
          // console.log("DATA: ", data);
          // await upsertUseCase().execute("daily_time_record", data);
        }

        // console.log("DATAAAAAA: ", data);
        // await upsertUseCase().execute("daily_time_record", data);
        // refetchData();
        // stats !== "Update" && dialog.close();
      } else {
        // no schedule
        // if (data.timeOut !== "--:--") {
        //   data.overtime = getOvertimeDuration(data.timeIn, data.timeOut);
        //   if (empOvertime.length > 0) {
        //     empOvertime[0].overtime = data.overtime;
        //     await upsertUseCase().execute("overtime", empOvertime[0]);
        //   }
        // }
        this.showError("No Schedule");
        // await upsertUseCase().execute("daily_time_record", data);
        // refetchData();
        // return;
      }
    } catch (e) {
      console.error(e);
    }
  }

  // Helper function to fetch required data
  async fetchData(employee, object, dailyTime) {
    return Promise.all([
      findObjectUseCase().execute("employees", {
        where: { id: employee.id },
        includes: ["selectedSchedule"],
      }),
      findObjectUseCase().execute("leave_request", {
        where: {
          "employee.id": employee.id,
          stats: { $nin: ["Rejected", "For Processing"] },
          startdate: { $lte: object.currentDate },
          enddate: { $gte: object.currentDate },
        },
      }),
      findObjectUseCase().execute("leave_cred", {
        where: {
          empID: dailyTime[0]?.employee?.id,
          type: "Vacation Leave",
        },
      }),
    ]);
  }

  // Helper function to return the day of the week
  getDayOfWeek(date) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[date.getDay()];
  }

  // Prepares the data object for either time-in or time-out scenarios
  prepareData(
    dailyTime,
    object,
    employee,
    currentYear,
    currentMonth,
    timeRecStats
  ) {
    if (dailyTime.length > 0) {
      return {
        ...dailyTime[0],
        timeOut: object.currentTimeOut,
        timeRecStats,
        year: currentYear,
        month: currentMonth,
        lateMinutes: 0, // Initialize lateMinutes to 0
      };
    }
    return {
      date: object.currentDate,
      timeIn: object.currentTime,
      employee,
      timeOut: "--:--",
      timeRecStats,
      year: currentYear,
      month: currentMonth,
      lateMinutes: 0, // Initialize lateMinutes to 0
    };
  }

  // Checks if there are any holidays
  handleHolidays(listofHolidays, data, timeRecStats) {
    listofHolidays.forEach((holiday) => {
      if (holiday.type) {
        timeRecStats.push(holiday.type);
      }
    });
  }

  // Checks if there are any approved leaves
  handleLeaves(listofLeaves, data, timeRecStats) {
    listofLeaves.forEach((leave) => {
      if (leave.selectedType) {
        timeRecStats.push(leave.selectedType);
      }
    });
  }

  // Checks if there are any work suspension
  handleSuspension(listofSuspension, data, timeRecStats) {
    // console.log("SUSPENSION: ", data);
    listofSuspension.forEach((suspension) => {
      if (suspension.type) {
        timeRecStats.push("SUSPENDED");
      }
    });
  }

  // Checks the schedule and updates the timeRecStats with LATE or UNDERTIME based on the time-in and time-out logic
  checkSchedule(
    schedule,
    employee,
    dayOfWeek,
    object,
    data,
    timeRecStats,
    dailyTime
  ) {
    // const schedule = employee.schedule.find((sched) => sched.day === dayOfWeek);
    if (schedule) {
      const newTimeNow =
        object.currentTime === "--:--"
          ? convertTo24HourTime(object.currentTimePmIn)
          : convertTo24HourTime(object.currentTime);

      const newTimeOut =
        object.currentTimeOut === "--:--"
          ? convertTo24HourTime(object.currentTimeAmOut)
          : convertTo24HourTime(object.currentTimeOut);
      const newSchedTimeIN = convertTo24HourTime(schedule.timein);
      const newSchedTimeOUT = convertTo24HourTime(schedule.timeout);
      // console.log("DAILTTTTTTTTTTTTT: ", dailyTime);
      if (
        data.timeOut === "--:--" ||
        data.timeAmOut === "--:--" ||
        dailyTime.length > 0
      ) {
        this.checkTimeIn(newTimeNow, newSchedTimeIN, timeRecStats, data);
      }
      if (
        dailyTime.length > 0 &&
        (data.timeOut !== "--:--" || data.timeAmOut !== "--:--")
      ) {
        this.checkTimeOut(
          newTimeOut,
          newSchedTimeOUT,
          dailyTime,
          timeRecStats,
          data
        );
      }
    } else {
      return;
    }
  }

  // computeCreditAddtion(recordLength) {
  //   let conversionValue = 0.0;

  //   for (let i = 1; i <= recordLength; i++) {
  //     // Reset the conversion value at the start of each 30-day cycle
  //     if ((i - 1) % 30 === 0) {
  //       conversionValue = 0.042; // Reset conversionValue to 0.042 at the start of each cycle
  //     } else if (i % 30 === 2) {
  //       conversionValue += 0.041; // Add 0.041 for the second day of each cycle
  //     } else if (((i % 30) - 2) % 3 === 1 || ((i % 30) - 2) % 3 === 2) {
  //       conversionValue += 0.042; // Add 0.042 on the 3rd, 4th, 6th, 7th, etc., within each cycle
  //     } else {
  //       conversionValue += 0.041; // Add 0.041 on the 5th, 8th, etc., within each cycle
  //     }
  //   }

  //   return conversionValue.toFixed(3);
  // }

  computeCreditDeduction(undertimeMinutes) {
    let conversionValue = 0.0;

    for (let i = 1; i <= undertimeMinutes; i++) {
      // Add 0.003 at 7th, 19th, 31st, 43rd, 55th minute of every hour
      if (
        i % 60 === 7 ||
        i % 60 === 19 ||
        i % 60 === 31 ||
        i % 60 === 43 ||
        i % 60 === 55
      ) {
        conversionValue += 0.003;
      } else {
        conversionValue += 0.002;
      }
    }

    return conversionValue.toFixed(3).toString();
  }

  // check time-in status (LATE)
  checkTimeIn(newTimeNow, newSchedTimeIN, timeRecStats, data) {
    const isOnTime =
      newTimeNow.hours < newSchedTimeIN.hours ||
      (newTimeNow.hours === newSchedTimeIN.hours &&
        newTimeNow.minutes <= newSchedTimeIN.minutes);

    if (!isOnTime) {
      const lateMinutes =
        (newTimeNow.hours - newSchedTimeIN.hours) * 60 +
        (newTimeNow.minutes - newSchedTimeIN.minutes);

      console.log("LATEMINUTE: ", lateMinutes);
      const conversionValue = this.computeCreditDeduction(lateMinutes);
      console.log("LATE: ", lateMinutes);
      timeRecStats.push("LATE");

      // Add lateMinutes to the data object
      data.lateMinutes = conversionValue;
    } else {
      console.log("NOT LATE");
      data.lateMinutes = 0;
    }
  }

  // check time-out status (UNDERTIME)
  checkTimeOut(newTimeOut, newSchedTimeOUT, dailyTime, timeRecStats, data) {
    const isOnTimeOut =
      newTimeOut.hours > newSchedTimeOUT.hours ||
      (newTimeOut.hours === newSchedTimeOUT.hours &&
        newTimeOut.minutes >= newSchedTimeOUT.minutes);

    if (!isOnTimeOut) {
      timeRecStats.push("UNDERTIME");
      let undertimeMinutes =
        (newSchedTimeOUT.hours - newTimeOut.hours) * 60 +
        (newSchedTimeOUT.minutes - newTimeOut.minutes);

      if (undertimeMinutes < 0) {
        undertimeMinutes = 0;
      }

      const conversionValue = this.computeCreditDeduction(undertimeMinutes);
      console.log("UNDERTIME: ", undertimeMinutes);
      const underTime =
        parseFloat(dailyTime[0].lateMinutes) + parseFloat(conversionValue);
      console.log("total Undertime: ", underTime);
      data.lateMinutes = underTime.toFixed(3).toString();
      data.isTimeOut = true;
    } else {
      data.lateMinutes = dailyTime[0].lateMinutes;
      data.isTimeOut = true;
    }
  }
}
